import { render } from "./RdvForm.vue?vue&type=template&id=01365318"
import script from "./RdvForm.vue?vue&type=script&lang=js"
export * from "./RdvForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__